import { actionTypes } from 'redux-form';
import { showError, showLoginFail, showUnverifiedAccount } from 'state/modules/dialog';
import authTypes from 'state/modules/auth/types';
import expressCheckinTypes from 'state/modules/expressCheckin/types';

// Helper function to safely convert message to string (handles both arrays and strings)
const normalizeMessage = message => {
  if (Array.isArray(message)) {
    return message.join(', ');
  }
  return typeof message === 'string' ? message : '';
};

export default ({ dispatch, getState }) => next => action => {
  const { error, type } = action;

  if (error) {
    let parsedError = {};
    try {
      parsedError = JSON.parse(error.message);
    }
    catch {
      parsedError = typeof error === 'object' ? error : { message: error };
    }

    switch (type) {
      case authTypes.LOGIN_FAIL:
        dispatch(showLoginFail({ passwordLogin: true }));
        break;
      case authTypes.SEND_LOGIN_LINK_FAIL:
        dispatch(showLoginFail({ loginLink: true }));
        break;
      case authTypes.SSO_FAIL:
        dispatch(showLoginFail({ ssoLogin: true }));
        break;
      case authTypes.REQUEST_FAIL:
        // Handle unverified account error for forgot password
        if (parsedError.code === 'guest.requiresVerification') {
          // Get the email from the form state (redux-form stores it)
          const state = getState();
          const email = state.form?.forgotPassword?.values?.email;
          if (email) {
            dispatch(showUnverifiedAccount(email));
            break;
          }
          // Fall through to show generic error if email is not available
        }
        // Fall through to default error handling
        dispatch(showError({
          title: 'general.error.title',
          message: 'general.error.message',
          code: parsedError.code,
        }));
        break;
      case actionTypes.SET_SUBMIT_FAILED:
        // Do not show error pop-up for redux-form submission failure. It's handled inline in the form.
        break;
      case expressCheckinTypes.LOOKUP_FOLIO_FAIL:
      case expressCheckinTypes.SUBMIT_CHECKIN_FAIL:
        // Express Check-in reports its own failures: a no-match inline under
        // the folio field, anything else as a step-level banner with a retry.
        // A pop-up on top would duplicate it.
        break;
      case authTypes.SIGNUP_FAIL:
        // Allow showing specific error messages for signup failures
        dispatch(showError({
          title: parsedError.error || 'general.error.title',
          message: normalizeMessage(parsedError.message) || 'general.error.message',
          code: parsedError.code,
        }));
        break;
      default:
        // Don't show error dialogs for authentication errors (401)
        // The app will handle auth failures appropriately
        if (parsedError.statusCode === 401) {
          break;
        }

        // Use generic error message instead of raw API error text
        dispatch(showError({
          title: 'general.error.title',
          message: 'general.error.message',
          code: parsedError.code,
        }));
    }

    next({ ...action, error: parsedError });
    return;
  }

  next(action);
};
